<template>
  <div>
    <el-dialog width="584px" center :visible.sync="dialogVisible" custom-class="dgLimitedDiglog" :show-close="false">
      <template slot="title">
        <div class="relative w-[100%] h-[78] bg-head">
          <div class="absolute top-[26] left-[54]">
            <img class="h-[32]" src="@/assets/img/public/dialog_head_title.png" alt="" />
          </div>
          <div class="absolute bottom-[0] right-[0]">
            <img class="w-[202] h-[116]" src="@/assets/img/public/dialog_head_desc.png" alt="" />
          </div>
          <div class="absolute top-[-20] right-[-20]">
            <i class="icon t-[24] t-[rgba(255,255,255,0.6)]" @click="dialogVisible = false">&#xe6eb;</i>
          </div>
        </div>
      </template>
      <div class="bg-[#fff] p-[24] rounded-bl-[16] rounded-br-[16]">
        <div class="max-h-[360] overflow-auto">
          <div v-for="item in coupons" :key="item.id" class="border-[2] border-solid border-[#FF3B3E] bg-linear-gradient2 rounded-[16] flex items-center relative rounded-[16] w-[100%] px-[24] py-[16] mb-[20]">
            <div class="text-center w-[120]">
              <p class="t-[#F53F3F] t-[14] font-900">
                <span v-if="item.couponType == 2">¥</span><span class="t-[28]">{{ item.moneyOrPercentage }}</span>
              </p>
              <p class="t-[#BD8474] t-[14] mt-[8]">{{ !item.configurationVo["minApplicableAmount"] || item.configurationVo["minApplicableAmount"] <= 0 ? "无门槛使用" : !item.configurationVo["maxApplicableAmount"] || item.configurationVo["maxApplicableAmount"] <= 0 ? `满${item.configurationVo["minApplicableAmount"]}元可用` : `${item.configurationVo["minApplicableAmount"]}~${item.configurationVo["maxApplicableAmount"]}元可用` }}</p>
            </div>
            <div class="mx-[16] w-[2] h-[94] border-r-[1] border-dashed border-[#F53F3F]"></div>
            <div class="flex-1">
              <p class="t-[12] t-[#BD8474]">*{{ item.couponEndTime }}到期</p>
              <p class="mt-[8] t-[16] t-[#7E2508] aui-ellipsis-2" v-html="item.configurationVo['couponName']"></p>
              <p class="t-[12] t-[#BD8474] mt-[18]">仅限制定保函品种可用<span v-if="item.configurationVo['firstOrderOnly'] == 1"> | 仅限首单</span></p>
            </div>
            <div class="absolute right-[-1] top-[0]">
              <img v-if="item.couponType == 2" class="w-[63] h-[26]" src="@/assets/img/public/mjq.png" alt="" />
              <img v-else class="w-[63] h-[26]" src="@/assets/img/public/zkq.png" alt="" />
            </div>
            <div class="absolute left-[152] bottom-[-2] top-border-semicircle"></div>
            <div class="absolute left-[152] top-[-2] bottom-border-semicircle"></div>
          </div>
        </div>
        <div class="pt-[20]">
          <div class="relative cursor-pointer w-[368] h-[53] leading-[53] text-center t-[#fff] t-[16] font-900 rounded-[24] apply-btn mx-[auto]" @click="handleGoRouter('/apply/index')">去投保</div>
          <p class="text-center t-[14] t-[#606266] mt-[14] cursor-pointer" @click="handleGoRouter('/coupon/index')">查看详情</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  name: "dgLimitedDiglog",
  data() {
    return {
      dialogVisible: false,
      coupons: [],
    };
  },
  watch: {},
  components: {},
  methods: {
    getCoupons() {
      ajax.post({
        url: "/customer/user/myDiscount",
        data: {},
        success: (res) => {
          this.coupons = res.discountVos || [];
          this.dialogVisible = res.read;
        },
      });
    },
    handleGoRouter(path) {
      this.dialogVisible = false;
      this.push({ path });
    },
  },
  created() {
    this.getCoupons();
  },
  mounted() {},
};
</script>
<style scoped lang="less">
// @import "~@/assets/css/var.less";

.bg-linear-gradient {
  background: linear-gradient(to right, #ff6c00, #ff3b3e);
}

.bg-linear-gradient2 {
  background: linear-gradient(90deg, #fef2f2 0%, #f9d6d2 100%);
}

.apply-btn {
  background-image: url("@/assets/img/public/btn_apply.png");
  background-size: 100% 100%;
  background-position: center;
}

// 上半圆
.top-border-semicircle {
  width: 16px;
  /* 宽度为高度的2倍 */
  height: 8px;
  border-radius: 8px 8px 0 0;
  /* 底部圆角 */
  border: 2px solid #ff3b3e;
  /* 边框颜色设置 */
  background-color: #ffffff;
  /* 透明背景仅显示边框 */
  border-bottom-color: #ffffff;
}

// 下半圆
.bottom-border-semicircle {
  width: 16px;
  /* 宽度为高度的2倍 */
  height: 8px;
  border-radius: 0 0 8px 8px;
  /* 底部圆角 */
  border: 2px solid #ff3b3e;
  /* 边框颜色设置 */
  background-color: #ffffff;
  /* 透明背景仅显示边框 */
  border-top-color: #ffffff;
}
</style>
<style lang="less">
.dgLimitedDiglog {
  background: transparent;
  box-shadow: none;
  margin-top: 25vh !important;

  .el-dialog__header {
    padding: 0;

    .bg-head {
      background-image: url("../assets/img/public/dialog_head_bg.png");
      background-size: 100% 100%;
      background-position: center;
    }
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>
